<div class="card p-5  grid grid-cols-4 gap-5">

    <div class="col-span-1">
        <div class="w-full h-[11rem]">
            <img class="w-full h-full object-fill rounded-md" [src]="getThumbnailUrl()" alt="Course thumbnail">
        </div>
    </div>
    <div class="col-span-2 flex flex-col justify-between">

        <div>
            <div class="flex items-center gap-3">
                <h3 class="text-lg font-semibold line-clamp-2 capitalize">{{data?.course_name}}</h3>
                <!-- <ng-container [ngSwitch]="data?.status ?? 'draft'">
                    <span *ngSwitchCase="'pending'"
                        class="bg-amber-500 text-amber-100 text-sm font-medium p-1 rounded-lg px-3 flex items-center gap-2 w-auto"><i
                            class="ri-hourglass-fill"></i>Pending</span>
                    <span *ngSwitchCase="'approved'"
                        class="bg-green-500 text-green-100 text-sm font-medium p-1 rounded-lg px-3 flex items-center gap-2 w-auto"><i
                            class="ri-checkbox-circle-fill"></i>Approved</span>
                    <span *ngSwitchCase="'draft'"
                        class="bg-gray-500 text-gray-100 text-sm font-medium p-1 rounded-lg px-3 flex items-center gap-2 w-auto"><i
                            class="ri-pencil-ruler-fill"></i>draft</span>

                </ng-container> -->
            </div>
            <p class="text-zinc-500 text-sm my-2 line-clamp-2">{{data?.description}}</p>
            <div class=" flex items-center gap-2 capitalize">
                <span class="text-amber-500 text-sm font-semibold"><i class="ri-star-fill"></i> {{data?.rating ??
                    '3.5'}}</span>
                <span
                    class="bg-zinc-100 text-wrap text-sm py-1.5 px-3 text-zinc-800 font-medium rounded-lg">{{getCourseTypeLabel()}}</span>
                <div class="dropdown dropdown-end">
                    <div #statusTrigger tabindex="0" role="button" class="btn btn-sm m-1 font-normal flex items-center">Status : <span
                                       class="font-semibold">{{data?.is_published === 1 ? 'Published' : 'Draft'}}</span>
                    </div>
                    <ul tabindex="0"
                        class="dropdown-content menu bg-base-100 rounded-box border z-[1] w-52 p-2 shadow-xl">
                        <li><a [class.pointer-events-none]="isStatusUpdating" (click)="!isStatusUpdating && onStatusMenuClick('draft', statusTrigger, $event)">Draft</a></li>
                        <li><a [class.pointer-events-none]="isStatusUpdating" (click)="!isStatusUpdating && onStatusMenuClick('publish', statusTrigger, $event)">Publish</a></li>
                    </ul>
                </div>

            </div>
        </div>

        <hr class="">

        <ul class="flex gap-3 uppercase">
            <li><span class="border text-wrap text-sm p-1 px-3 text-zinc-800 font-medium rounded-lg">ID:
                    <strong>{{data?.id}}</strong> </span></li>
            <li><span class="border text-wrap text-sm p-1 px-3 text-zinc-800 font-medium rounded-lg">purchase:
                    <strong>{{data?.purchases ?? '0'}}</strong> </span></li>
            <li><span class="border text-wrap text-sm p-1 px-3 text-zinc-800 font-medium rounded-lg">comments:
                    <strong>{{data?.comments ?? '0'}}</strong> </span></li>
        </ul>

    </div>
    <div class="col-span-1">

        <ul class="flex flex-col gap-3 justify-center h-full">
            <li><a [routerLink]="['/edit-courses', getCourseTypeSlug(), data?.id]"
                    [queryParams]="{tab:'structure'}" routerLinkActive="router-link-active"
                    class="btn w-full capitalize">Structure</a></li>
            <li><a [routerLink]="['/edit-courses', getCourseTypeSlug(), data?.id]"
                    [queryParams]="{tab:'details'}" class="btn w-full capitalize">details</a></li>
            <li><a [routerLink]="['/edit-courses', getCourseTypeSlug(), data?.id]"
                    [queryParams]="{tab:'other'}" class="btn w-full capitalize">others</a></li>
        </ul>

    </div>

</div>
